module.exports = "../img/wezilit-bY_4jXX.svg";